import React, {useRef, forwardRef, useMemo, MutableRefObject} from 'react'
import ReactDOM from 'react-dom'

interface Props {
    children: React.ReactNode
}

type ElementType = Maybe<HTMLElement>
type HTMLElRef = MutableRefObject<ElementType>

/**
 * 모달이 한 번도 열리지 않아도 `ModalProvider` 마운트 시 Portal DOM 노드가 body에 추가됩니다.
 * 페이지 내 `ModalProvider`가 많을수록 불필요한 DOM 노드가 누적됩니다.
 * 이를 한번만 만들어서 재사용합니다.
 */
const mainContainer = document.createElement('div')
mainContainer.id = 'portal__modal'
document.body.appendChild(mainContainer)

const usePortal = () => {
    const portal = useRef(null) as HTMLElRef

    const Portal = useMemo(
        () =>
            // eslint-disable-next-line react-hooks/refs
            forwardRef<ElementType, Props>(({children}, ref) => {
                if ((ref as HTMLElRef)?.current) {
                    ;(ref as HTMLElRef).current = portal?.current || null
                }

                return ReactDOM.createPortal(children, mainContainer as Element)
            }),
        [portal],
    )

    return {
        Portal,
    }
}

export default usePortal
